import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container, Message, Icon } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { showAssignTagsModal } from 'actions/modal.js';
import { previousPage } from 'actions/navigationBar';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);
export default function RightPanelOrTopPanel(props) {
  const dispatch = useDispatch();
  const openAssignTagsModal = () => {
    dispatch(showAssignTagsModal(true));
  };

  const isWaitingAreaLoaded = props.waitingArea && props.waitingArea.id > 0;

  const buttonsForDesktop =
    props.availableTags != null ? (
      props.availableTags.length > 0 ? (
        <div>
          <button
            type="button"
            className="ui labeled icon button mrbs color-button color-white right-hand-side-button"
            onClick={openAssignTagsModal}
          >
            <i className="tag icon" />
            {APP.LANGUAGE.WaitingAreaManageTags.AssignTagButtonText}
          </button>
        </div>
      ) : (
        <Message
          icon
          className="borderless bg-transparent pdlnull pdrnull"
          style={{ paddingTop: '11px', paddingBottom: '21px' }}
        >
          <Icon name="tags" className="mrrm" style={{ fontSize: '1.5em' }} />
          <Message.Content>
            <h4>{htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaManageTags.NoAvailableTagMsg))}</h4>
          </Message.Content>
        </Message>
      )
    ) : (
      ''
    );

  const buttonsForTablet =
    props.availableTags != null ? (
      props.availableTags.length > 0 ? (
        <div>
          <button
            className="ui labeled icon button color-button color-white right-hand-side-button mrrsss mrbml"
            onClick={openAssignTagsModal}
          >
            <i className="tag icon" />
            {APP.LANGUAGE.WaitingAreaManageTags.AssignTagButtonText}
          </button>
        </div>
      ) : (
        <Message icon className="borderless bg-transparent pdlnull pdrnull pdtnull pdbnull">
          <Message.Content>
            <h4>{htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaManageTags.NoAvailableTagMsg))}</h4>
          </Message.Content>
        </Message>
      )
    ) : (
      ''
    );

  const buttonsForMobile =
    props.availableTags != null ? (
      props.availableTags.length > 0 ? (
        <div>
          <button className="ui icon button color-button color-white mrrsss" onClick={openAssignTagsModal}>
            <i className="tag icon" />
          </button>
        </div>
      ) : (
        <Message icon className="borderless bg-transparent pdlnull pdrnull pdtnull pdbnull" style={{ height: '51px' }}>
          <Message.Content>
            <h4>{htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaManageTags.NoAvailableTagMsg))}</h4>
          </Message.Content>
        </Message>
      )
    ) : (
      ''
    );

  return (
    <div style={{ height: '100%' }}>
      <Container fluid as={Media} greaterThanOrEqual="computer" style={{ height: '100%' }}>
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdtxl pdbm pdrm logo-on-right-hand">
            <img className="ui image pdtxs umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo.default} />
            <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo.default} />
          </div>
          <div className="pdbs pdll pdrm">{buttonsForDesktop}</div>
          <div className="pdbm pdrm pdlm">{props.bottomSession}</div>
        </div>
      </Container>
      <Container fluid as={Media} at="tablet">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdlm pdrm">{buttonsForTablet}</div>
          {isWaitingAreaLoaded && (
            <div className="mrts pdts mrbm">
              <Link
                className={
                  (props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? 'back-to-org-link '
                    : 'back-to-wa-link color-waiting-area-text ') + 'left-text pdlm pdbs'
                }
                to={
                  props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? `/organisational-unit/view-all`
                    : `/waiting-area/view-one/${props.waitingArea.id}`
                }
                onClick={() => {
                  dispatch(previousPage(APP.LANGUAGE.WaitingAreaManageTags.PageHeaderTitle));
                }}
              >
                <i className="chevron circle left icon" />
                <span>
                  {props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                    : APP.LANGUAGE.WaitingAreaManageUsers.BackToWaitingAreaLinkText}
                </span>
              </Link>
            </div>
          )}
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdbm pdlm pdrm">{buttonsForMobile}</div>
          {isWaitingAreaLoaded && (
            <div className="mrbm">
              <Link
                className={
                  (props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? 'back-to-org-link '
                    : 'back-to-wa-link color-waiting-area-text ') + 'left-text pdlm pdbs'
                }
                to={
                  props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? `/organisational-unit/view-all`
                    : `/waiting-area/view-one/${props.waitingArea.id}`
                }
                onClick={() => {
                  dispatch(previousPage(APP.LANGUAGE.WaitingAreaManageTags.PageHeaderTitle));
                }}
              >
                <i className="chevron circle left icon" />
                <span>
                  {props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                    ? APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                    : APP.LANGUAGE.WaitingAreaManageUsers.BackToWaitingAreaLinkText}
                </span>
              </Link>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}

RightPanelOrTopPanel.propTypes = {
  waitingArea: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
};
